<script setup>
const { variant = 'neutral' } = defineProps({
    variant: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <span
        class="rounded-full px-2.5 py-1 text-xs font-bold whitespace-nowrap"
        :class="{
            'bg-gray-100 text-gray-600 ring-1 ring-gray-200':
                variant === 'neutral',
            'bg-green-100 text-green-700': variant === 'success',
            'bg-blue-100 text-blue-700': variant === 'info',
            'bg-amber-100 text-amber-700': variant === 'warning',
            'bg-red-100 text-red-700': variant === 'danger',
        }"
    >
        <slot />
    </span>
</template>
